import classNames from 'classnames'

import { Skeleton } from '../../Skeleton'

import * as styles from './CheckboxSkeleton.module.css'

function CheckboxSkeleton() {
  return (
    <div className={styles.CheckboxSkeleton}>
      <Skeleton className={classNames(styles.skeleton, styles.icon)} />
      <Skeleton className={classNames(styles.skeleton, styles.text)} />
    </div>
  )
}

export default CheckboxSkeleton
